import { z } from 'zod';

const envSchema = z.object({
  VITE_DIRECTUS_API_URL: z.url(),
  VITE_FEATURE_GOGIGI_PROMOTER_LINKS: z.string().optional(),
  VITE_FRONTEND_URL: z.string().optional(),
});

export const env = envSchema.parse(import.meta.env);
